import { render, staticRenderFns } from "./edit-referral-request.vue?vue&type=template&id=26d845b2&scoped=true&"
import script from "./edit-referral-request.vue?vue&type=script&lang=js&"
export * from "./edit-referral-request.vue?vue&type=script&lang=js&"
import style0 from "./edit-referral-request.vue?vue&type=style&index=0&id=26d845b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d845b2",
  null
  
)

export default component.exports